import { useFullscreen } from '@vueuse/core';

export const useFullScreen = () => {
	const { isFullscreen, toggle } = useFullscreen( document.body );
	return { isFullscreen, toggle };
};
